import type { AddonPricingUnit } from '@/modules/venue-cabinet/vc-venue-edit/views/vc-space-addons/types';

// [singular, plural] count noun per pricing unit; per_event has no countable unit (quantity is always 1).
const ADDON_UNIT_NOUNS: Record<AddonPricingUnit, [string, string]> = {
  per_event: ['event', 'events'],
  per_item: ['item', 'items'],
  per_person: ['person', 'people'],
  per_hour: ['hour', 'hours'],
};

/**
 * Resolves the count noun shown after a grouped add-on's quantity
 * (e.g. "5 people", "3 hours"). Returns undefined when the pricing unit is
 * absent or has no countable noun, so callers can render just "x N".
 */
export function resolveAddonUnit(
  pricingUnit: AddonPricingUnit | null | undefined,
  quantity: number,
): string | undefined {
  const nouns = pricingUnit ? ADDON_UNIT_NOUNS[pricingUnit] : undefined;
  if (!nouns) {
    return undefined;
  }

  const [singular, plural] = nouns;
  const noun = quantity === 1 ? singular : plural;

  return noun || undefined;
}
